<div
	class="form-control select-control"
	[formGroup]="form"
	[class.invalid]="isInvalid()"
	[class.valid]="isValid()"
	[class.required]="isRequired()"
	[class.has-validation-icon]="show_validation_icon"
>
	<label for="control" [for]="form_control_id" class="label">{{ label }}{{ getRequired() }} {{ getError() }}</label>
	<div class="control-container" [class.in-focus]="is_focused">
		<label *ngIf="!!prefix" [for]="form_control_id" class="prefix">{{ prefix }}</label>
		<div>
			<i class="icon-chevron-down"></i>
			<select
				id="control"
				[id]="form_control_id"
				[attr.name]="form_control_name"
				[formControlName]="form_control_name"
				[ngClass]="input_css_class"
				[class.select-placeholder]="form.get(form_control_name).value === '' && !!placeholder"
				[attr.disabled]="disabled ? '' : null"
				(change)="onChange()"
				(focus)="onFocus()"
				(blur)="onBlur()"
			>
				<option *ngIf="placeholder" value="" disabled="disabled" selected="selected">
					{{ placeholder }}
				</option>
				<option
					*ngFor="let o of options"
					[value]="o.value"
					[disabled]="o.disabled || null"
					[ngClass]="{ hidden: o.value === '' && !empty_allowed }"
				>
					{{ o.name }}
				</option>
			</select>
		</div>
		<label *ngIf="!!suffix" [for]="form_control_id" class="suffix">{{ suffix }}</label>
		<div class="validation-icon">
			<i class="fas fa-check"></i>
			<i class="fas fa-xmark"></i>
		</div>
	</div>
	<span *ngIf="hasInfo()" class="info" [class.highlighted]="highlighted_info">{{ info }}</span>
</div>
